import React from "react";

// Official Lutrom Engineering logo (white version generated from supplied brand asset).
const Logo = ({ height = 38, className = "" }) => {
  return (
    <img
      src="/brand/lutrom-logo-white.png"
      alt="Lutrom Engineering"
      style={{ height, width: "auto", display: "block" }}
      className={className}
      data-testid="lutrom-logo"
      draggable={false}
    />
  );
};

export default Logo;
